"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const TopBar_1 = require("./TopBar");
const useStyles = makeStyles_1.default(theme => ({
    root: {
        paddingTop: TopBar_1.topBarHeight(theme) + theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
}));
// eslint-disable-next-line react/prop-types,@typescript-eslint/no-unused-vars
exports.MainContainer = ({ maxWidth, children, ...props }) => {
    const classes = useStyles();
    return (
    // eslint-disable-next-line react/prop-types
    react_1.default.createElement(Container_1.default, Object.assign({ className: `${classes.root} ${props.classes && props.classes}`.trim(), maxWidth: "md" }, props), children));
};
exports.MainContainer.propTypes = {
    children: prop_types_1.default.node.isRequired,
};
//# sourceMappingURL=MainContainer.js.map